var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.component
    ? _c(
        "div",
        {
          staticClass:
            "gfu-label--light _mt-1 _flex _ac-c _jc-c _tac _px-1 _py-1 _fa--sm _rounded--common",
          attrs: { "data-qa": "payment-info" },
        },
        [
          _c(
            _vm.component.component,
            _vm._b(
              { tag: "component" },
              "component",
              _vm.component.props,
              false
            )
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }